import {
  AlertCircleIcon,
  Cancel01Icon,
  CheckmarkCircle02Icon,
  InformationCircleIcon,
} from '@hugeicons/core-free-icons';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { IconComponent } from 'components/Icon/IconComponent';

import styles from './FormMessage.module.scss';

export const MessageType = {
  Success: 'Success',
  Error: 'Error',
  Info: 'Info',
  Warning: 'Warning',
  Neutral: 'Neutral',
};

export const FormMessage = ({
  message = '',
  type = MessageType.Error,
  className,
  onClose = () => {},
  closeable = true,
  noMargin = false,
}) => {
  if (!message) return null;

  return (
    <div
      className={cn(
        styles.root,
        styles[`root${type}`],
        { [className]: className },
        { [styles.noMargin]: noMargin },
        'u-border-radius--medium',
      )}>
      <div className="d-flex align-items-center">
        {type === MessageType.Error && (
          <IconComponent icon={AlertCircleIcon} noBackground type="error" />
        )}
        {type === MessageType.Success && (
          <IconComponent icon={CheckmarkCircle02Icon} noBackground type="success" />
        )}
        {(type === MessageType.Info || type === MessageType.Neutral) && (
          <IconComponent icon={InformationCircleIcon} noBackground type="info" size="small" />
        )}
        {type === MessageType.Warning && (
          <IconComponent icon={AlertCircleIcon} noBackground type="warning" />
        )}
        <p className={styles.message} dangerouslySetInnerHTML={{ __html: message }}></p>
      </div>
      {closeable && (
        <IconComponent icon={Cancel01Icon} noBackground onClick={onClose} type={type} />
      )}
    </div>
  );
};

FormMessage.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf([
    MessageType.Success,
    MessageType.Error,
    MessageType.Info,
    MessageType.Warning,
    MessageType.Neutral,
  ]),
  className: PropTypes.string,
  onClose: PropTypes.func,
};
